export const APPLICATION_NAME = 'TrustEd Apps Management Suite';
